import React, {Component, ComponentProps, ReactNode, Suspense} from 'react';
import {Route, Switch, withRouter} from 'react-router-dom';
import {appInfo, middleware, ua} from '@weapp/utils';
import VueRouterMain from "./VueRouterMain";

const { publicUrl, libraryName } = appInfo('@weapp/ecodesdk');
@middleware(libraryName, 'Switch')
class Main extends Component<ComponentProps<any>, any> {

  // @ts-ignore
  updateRoute=(route:any,childRoutePath:string,path:string)=>{
    const {isAllRoute} = this.props;
    const {path:childPath,children} = route?.props||{};
    let otherParams:any = {};
    if(route?.type===Route && childPath){
      if(Array.isArray(childPath)){
        otherParams.path = childPath.map(item1=>{
          if(item1.indexOf(path)===0){
            return  childRoutePath+(isAllRoute?item1:item1.replace(path,''))
          }else {
            return item1;
          }
        })
      } else {
        if(childPath.indexOf(path)===0){
          otherParams.path = childRoutePath+(isAllRoute?childPath:childPath.replace(path,''));
        }
      }
      return {
        ...route,
        props:{
          ...route.props,
          ...otherParams
        }
      };
    }else if(children){
      return {
        ...route,
        props:{
          ...route.props,
          children:this.renderChildRoute(children,childRoutePath,path)
        }
      }
    }else {
      return route;
    }
  }

  // @ts-ignore
  renderChildRoute=(childrenRoute:ReactNode,childRoutePath:string,path:string)=>{
    if(Array.isArray(childrenRoute)){
      return childrenRoute.map((item:any)=>this.updateRoute(item,childRoutePath,path))
    }else {
      return this.updateRoute(childrenRoute,childRoutePath,path)
    }
  }

  render() {
    const { children, weId,isChildRoute,match,isAllRoute=false, parentPath } = this.props;
    const ecodePathPrefix = `/${(ua.device !== 'PC' || /^\/mobile/.test(window.location.pathname)) ? 'mobile' : 'sp'}/custom`;
    let path = `${publicUrl}${ecodePathPrefix}`;
    let childRoutePath = '';
    if(isChildRoute){
      childRoutePath = (parentPath || match.url.replace(/\/$/, () => ''))+(isAllRoute?'':'/custom');
    }
    return (
      <>
        <Route weId={`${weId}_7smbli`} path={childRoutePath||path}>
          <Switch weId={`${weId}_zami6c`}>
            {
              isChildRoute?this.renderChildRoute(children,childRoutePath,path):children
            }
          </Switch>
        </Route>
        <VueRouterMain
            weId={`${this.props.weId || ''}_xooxru`}
            reactRouterPath={path}
            childRoutePath={childRoutePath}
            isAllRoute={isAllRoute}
            ecodePathPrefix={ecodePathPrefix}
            isChildRoute={isChildRoute}
        />
      </>
    )
  }
}

export default withRouter(Main);